import React from 'react';

import {
    Card,
    Button,
    Table,
    message,
    Select,
    Modal,
} from 'antd';

import FilterRow from './filter-row'
import ColumnSelector from './column-selector';

import {
    _getTableNames,
    _getFieldNames,
    _postDataQuery,
    _postDownloadDataQuery
} from '../../services'

import './index.css'

const DEFAULT_COLUMNS = ['id']

const { Option } = Select;

class ReportBuilder extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            fieldNames: [],
            selectedTable: 'product',
            selectedFields: DEFAULT_COLUMNS, 
            query: [{
                fieldName: '',
                condition: '',
                value: '',
            }],
            data: [],
            dataLength: 0,
            tableNames: [],
        }
    }

    render() {

        const {fieldNames, query, selectedFields} = this.state

        return(
            <div>
                <Card 
                    title='Search Data by the following'>
                        <div className='header-section-top'>
                            <h3>Select A Table</h3>
                            {this.renderTableSelect()}
                        </div>
                        <div className='header-section'>
                            <h3>Select Filters</h3>
                            {query.map((_query, i) => 
                                <FilterRow 
                                    fieldName={_query.fieldName}
                                    condition={_query.condition}
                                    value={_query.value}
                                    index={i}
                                    fieldNames={fieldNames}
                                    onFieldChange={this.onFieldChange}
                                    removeQuery={this.removeQuery}
                                    deleteActive={query.length>1}
                                    />
                                
                            )}
                            <div className='button-container'>
                                <Button onClick={this.addQuery}>Add A Filter</Button>
                                <div style={{marginLeft: 'auto'}}>
                                    <Button
                                        style={{marginRight: 5}}
                                        onClick={this.clearQuery}>Clear</Button>
                                </div>
                            </div>
                        </div>
                        <div className='header-section'>
                            <h3>Select Columns to Display</h3>
                            <ColumnSelector 
                                fieldNames={fieldNames}
                                selectedFields={selectedFields}
                                onColumnSelectedChange={this.onColumnSelectedChange}
                                DEFAULT_COLUMNS={DEFAULT_COLUMNS}
                                />
                        </div>
                        <div className='header-section' style={{display: 'flex'}}>
                            <div style={{marginLeft:'auto'}}>
                                <Button
                                    onClick={this.searchQuery}
                                    type="primary">Search</Button>
                            </div>
                        </div>
                </Card>
                <Card>
                    {this.renderTable()}
                </Card>
            </div>
        )
    }

    componentDidMount() {
        _getTableNames()
        .then(data => {
            this.setState({
                tableNames: data.data
            }, this.getFieldNames)
        })
    }

    getFieldNames = () => {

        const {selectedTable} = this.state

        message.loading('Getting Field Names')
        this.setState({
            fieldNames: [],
        }, () => {
            return _getFieldNames(selectedTable)
            .then(_fieldNames => {
                this.setState({
                    fieldNames: _fieldNames.data
                }, () => {
                    message.destroy()
                    message.success('Table Updated!', 5)
                })
            })
        })


    }

    /**
     * Table Selector 
     */

    renderTableSelect = () => {

        const { tableNames } = this.state

        return (
            <div>
                <Select
                    style={{ width: '25%' }}
                    placeholder="Select a Table"
                    optionFilterProp="children"
                    defaultValue='product'
                    onChange={(value) => this.handleTableSelectChange(value)}
                >
                    {tableNames.map(_table => {
                        return <Option value={_table}>{_table}</Option>
                    })}
                </Select>
            </div>
        )
    }

    handleTableSelectChange = (value) => {
        this.setState({ 
            selectedTable: value,
            selectedFields: DEFAULT_COLUMNS
        }, () => {
            this.getFieldNames()
            this.clearQuery()
        })
    }

    /**
     * Filters
     */

    renderTable = () => {

        const {data, selectedFields} = this.state

        var columns = []

        if (data.length>0) {
            selectedFields.map(_selectedField => {
                return columns.push({
                    title: _selectedField,
                    dataIndex: _selectedField,
                    render: (data) => `${data}`
                })
            })
        }

        return (
            <Table
                columns={columns}
                dataSource={data}
                size="small"
                pagination={{pageSize:50}}
                title={() => this.renderDownloadButton()}
            />
        )
    }

    addQuery = () => {
        this.setState({
            query: [
                ...this.state.query,
                {
                    fieldName: '',
                    condition: '',
                    value: '',
                }
            ]
        })
    }

    removeQuery = (index) => {
        this.setState({
            query: this.state.query.filter(
                (_, i) => i!== index
            )
        })
    }

    clearQuery = () => {
        this.setState({
            query: [{
                fieldName: '',
                condition: '',
                value: '',
            }]
        })
    }

    onFieldChange = (value, field, index) => {
        this.setState({
            query: this.state.query.map((v,i) => {
                if (i===index) {
                    v[field]=value
                }
                return v
            })
        })
    }

    onColumnSelectedChange = (targetKeys) => {
        this.setState({
            selectedFields: targetKeys 
        })
    }

    searchQuery = () => {
        const {query, selectedFields, selectedTable} = this.state

        message.loading(`Getting Data`, 0);

        _postDataQuery({query, selectedFields, selectedTable})
        .then(result => {

            message.destroy();
            message.success(`Found ${result.data.length} results`);

            this.setState({
                data: result.data,
                dataLength: result.data.length
            })

        }).catch( (err) => {
			message.destroy();
			message.error('There was an Error');
		})
    }

    /**
     * Download
     */
    renderDownloadButton = () => {
        return (
            <div style={{display: 'flex', alignItems: 'center'}}>
                <Button onClick={() => this.handleDownloadClick()}>Download</Button>
                <div style={{marginLeft: 'auto'}}><b>{this.state.dataLength}</b> results found</div>
            </div>
        )
    }

    handleDownloadClick = () => {

        const {query, selectedFields, selectedTable} = this.state

        _postDownloadDataQuery({query, selectedFields, selectedTable})
        .then(() => {
            return Modal.info({
                centered: true,
                title: "Data Report",
                content: "The Data Report will be sent to your email once it's ready"
            })
        })
        .catch(err => {
            return Modal.error({
                centered: true,
                title: "Data Report",
                content: "There was an error. Please check your parameters"
            })
        })

    }
}

export default ReportBuilder


// WEBPACK FOOTER //
// ./src/components/data/report-builder.js